import { InfluencerMarketingIcon, InfluencerAffiliateIcon, SalesOutreachIcon, LeadsIcon, CreditCardIcon } from '@/components/icons';


export enum CampaignMarketingStrategy {
  INFLUENCER_MARKETING = 'influencer_marketing',
  AFFILIATES_MARKETING = 'affiliates_marketing',
  SALES_OUTREACH = 'sales_outreach',
}

export const options = [
  {
    label: 'Influencer marketing',
    value: CampaignMarketingStrategy.INFLUENCER_MARKETING,
    prompt: 'Best for brands looking to elevate awareness and build trust',
    desc: 'Pay influencers a fixed fee to create custom content promoting your product. Best for brand awareness, product launches, or when you want full content control.',
    Icon: InfluencerMarketingIcon,
    mark: 'Goal: website traffic'
  },
  {
    label: 'Affiliate marketing',
    value: CampaignMarketingStrategy.AFFILIATES_MARKETING,
    prompt: "Ideal for eCommerce and SaaS brands focused on driving sales",
    desc: 'Performance-based partnership where influencers earn commissions for driving measurable sales',
    Icon: InfluencerAffiliateIcon,
    mark: 'Goal: sales'
  },
  // {
  //   label: 'Cold email',
  //   value: CampaignMarketingStrategy.SALES_OUTREACH,
  //   desc: 'Send targeted emails to potential customers or partners to initiate business relationships',
  //   Icon: SalesOutreachIcon,
  //   mark: 'Goal: leads'
  // },
];

export const marketingStrategyLab: any = {
  [CampaignMarketingStrategy.INFLUENCER_MARKETING]: 'Influencer marketing',
  [CampaignMarketingStrategy.AFFILIATES_MARKETING]: 'Influencer affiliate',
  [CampaignMarketingStrategy.SALES_OUTREACH]: 'Sales outreach',
}

export const enterpriseSolutionType = 'EnterpriseSolution'

export const enterpriseSolution = [{
  label: 'Enterprise solution (ideal for established brands）',
  value: enterpriseSolutionType,
  desc: '',
  Icon: LeadsIcon,
  markIcon: CreditCardIcon,
  mark: 'Additional set up fee: Final set-up fee depends on campaign size and will be shared before launch',
  descList: ['Review email invite templates', 'Remove competitor contacts from outreach', 'Use brand-customized domain', 'Create branded promotional links']
}]